import { GetPlayerDetailResponse } from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerDetail } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerDetail(
	id: string,
	props?: UseBaseQueryOptions<GetPlayerDetailResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerDetail, id],
		queryFn: () => getPlayerDetail(id),
		...props,
	})
}
